export default __webpack_public_path__ + "static/index-bg-c61d8e5168595143ff47c57114e549bc.jpg";